import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings"
import {CardViewLayout} from "../../../gd-ui/card-view-selector/card-view-selector"

const fieldsConfig = {

    'bg': {
        type            : 'option',
        defaultValue    : 'white',
        options         : ['gray','white']
    },
    'hideEmptyFolders': {
        type            : 'value',
        defaultValue    : false,
    },
    'freezeHeader': {
        type            : 'value',
        defaultValue    : true,
    },
    'itemViewBorderPosition': {
        type            : 'value',
        defaultValue    : CardViewLayout.COLOR_CODING_NONE,
    },
    'colorTasksFieldId': {
        type            : 'value',
        defaultValue    : 'statusId',
    }
}

// Note: 'itemViewBorderPosition' and 'colorTasksFieldId' are currently unused
// Consider removing them if they are no longer needed in the future

export default class UserSettingsViewsTaskList extends ServerSettings {

    public bg                       : any
    public hideEmptyFolders         : any
    public freezeHeader             : any
    public itemViewBorderPosition   : CardViewLayout
    public colorTasksFieldId        : ID

    constructor(config: any) {

        super(config, fieldsConfig)

        this.bg                         = this.initValue('bg')
        this.hideEmptyFolders           = this.initValue('hideEmptyFolders')
        this.freezeHeader               = this.initValue('freezeHeader')
        this.itemViewBorderPosition     = this.initValue('itemViewBorderPosition')
        this.colorTasksFieldId          = this.initValue('colorTasksFieldId')
    }

    toJson() {
        const result = {}

        this.valueToJson(result, 'bg')
        this.valueToJson(result, 'hideEmptyFolders')
        this.valueToJson(result, 'freezeHeader')
        this.valueToJson(result, 'itemViewBorderPosition')
        this.valueToJson(result, 'colorTasksFieldId')

        return result
    }
}
